<template>
  <div class="shipping-schedule-dialog">
    <el-dialog
      :visible.sync="innerVisible"
      :title=" this.$t('SeaExport.SailingDate') + $t('SeaExport.Select')"
      width="1240px"
      :show-close="true"
      :close-on-click-modal="false"
      :append-to-body="appendToBody"
    >
      <tab-shippping-schedule ref="tabShipppingSchedule" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import TabShipppingSchedule from '@/views/cargo/v0/SeaExport/Vessel/components/tabShipppingSchedule.vue'

export default {
  name: 'ShippingScheduleDialog',
  components: { TabShipppingSchedule },
  props: {
    visible: { type: Boolean, required: true },
    callback: { type: Function, default: null },
    appendToBody: { type: Boolean, default: () => false }
  },
  data() {
    return {
      innerVisible: false,
      data: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onshow(newVal) {
      this.data = newVal
      this.data.visible = true
      this.$nextTick(() => {
        this.$refs.tabShipppingSchedule.onshow(true, this.data)
      })
    }
  }
}
</script>

<style lang="scss">
.shipping-schedule-dialog {
}
</style>
